import React, { ChangeEvent } from 'react';

import { Paper } from '@mui/material';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './NgzCoachProfileCard.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CoachStatusInfo } from '../../components/CoachStatusInfo/CoachStatusInfo';
import { Point, UploadAvatarIcon } from '../../../shared/components/ui-components';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { useUserRoleLabel } from '../../../shared/hooks/useUserRoleLabel';

type NgzCoachProfileCardProps = {
  name?: string;
  gymName?: string;
  avatar?: string | null;
  isActive: boolean;
  onAvatarChange?: (data: { newAvatar: File }) => void;
};

const NgzCoachProfileCard = observer(
  ({ name, gymName, avatar, isActive, onAvatarChange }: NgzCoachProfileCardProps) => {
    const { isCoach } = loggedInUserDataStore;
    const { getForAgent } = useUserRoleLabel();

    const handleUploadAvatar = async (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && onAvatarChange) {
        onAvatarChange({ newAvatar: event.target.files[0] });
      }
    };

    return (
      <Paper variant="roundedBox" className={classes.container}>
        <UploadAvatarIcon
          name={name}
          avatar={avatar}
          onAvatarChange={handleUploadAvatar}
          disabled={!isCoach}
        />
        <div className={classes.infoBox}>
          <h3 className={classNames(classes.name, 'private-info')}>{name}</h3>
          <div className={classes.descriptionBox}>
            <span>{getForAgent()}</span>
            <Point />
            <div className="private-info">
              <span className={classes.label}>Entity:&nbsp;</span>
              {gymName}
            </div>
            <Point />
            <CoachStatusInfo isActive={isActive} iconSize="small" />
          </div>
        </div>
      </Paper>
    );
  },
);

angularizeWithProviders(NgzCoachProfileCard, 'ngzCoachProfileCard', {
  name: '<',
  gymName: '<',
  avatar: '<',
  isActive: '<',
  onAvatarChange: '&',
});

export { NgzCoachProfileCard };
